import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BranchesModel } from 'common/models/page-models/Branches/branches-data-model';
import { BranchesListingModel } from 'common/models/page-models/Branches/branches-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { BranchesGridWidgetService } from 'common/widget/branches/branches-grid-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class BranchesGridResolver extends GridResolver<BranchesModel, BranchesListingModel> {
    constructor(
        protected fs: BranchesGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}